import {Templates} from './Templates.js';

export class Message extends HTMLElement {
	constructor() {
		super();
		[this.el, this.$] = Templates("Message");
		this.attachShadow({mode:"open"});
		this.shadowRoot.appendChild(this.el);
		this.$.close.addEventListener(`click`, evt=>{
			evt.stopPropagation();
			this.remove();
		});
	}
	connectedCallback() {}
}
export class Messages extends HTMLElement {
	constructor() {	
		super();
		[this.el, this.$] = Templates("Messages");
		this.attachShadow({mode:"open"});
		this.shadowRoot.appendChild(this.el);
	}
	connectedCallback() {}
}
customElements.define(`lateral-messages`, Messages);
customElements.define(`lateral-message`, Message);